import { render, staticRenderFns } from "./activity-details.vue?vue&type=template&id=65e14eec&scoped=true&"
import script from "./activity-details.ts?vue&type=script&lang=ts&"
export * from "./activity-details.ts?vue&type=script&lang=ts&"
import style0 from "./activity-details.scss?vue&type=style&index=0&id=65e14eec&lang=scss&scoped=true&"
import style1 from "./activity-details.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e14eec",
  null
  
)

export default component.exports